import useApi from '../../../services/useApi'
import { toLabelValue } from '../utils'

const useGetSuppliers = () => {
  const Api = useApi()

  const {data: response, isFetching} = Api.useGetQuery('/analytics/zoho/payment/suppliers')

  return {
    suppliersList: toLabelValue(response?.data || []),
    isLoadingSuppliers: isFetching,
  }
}

export default useGetSuppliers
